var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.closed,
          expression: "!closed"
        }
      ],
      staticClass: "newsletter-subscribe-overlay"
    },
    [
      _c(
        "div",
        {
          ref: "dialog",
          staticClass: "newsletter-subscribe-popup",
          attrs: { role: "dialog", tabindex: "-1" }
        },
        [
          _c(
            "div",
            { class: { "newsletter-subscribe-popup-header": _vm.signed } },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between pb-2" },
                [
                  _c(
                    "div",
                    { staticClass: "newsletter-subscribe-popup-logo" },
                    [
                      !_vm.signed
                        ? _c("logo", { attrs: { disableFocus: "" } })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "round-icon-button",
                      attrs: { type: "button" },
                      on: { click: _vm.close }
                    },
                    [_c("span", { staticClass: "icon-close" })]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.signed
                ? _c(
                    "h1",
                    { staticClass: "newsletter-subscribe-popup-greetings" },
                    [
                      _vm._v(
                        "\n                TAK FOR DIN TILMELDING!\n            "
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          !_vm.signed
            ? _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-2" }, [
      _c("h1", [
        _vm._v(
          "\n                  TILMELD DIG KUNSTFONDENS NYHEDSBREV\n                "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                  Vi går tæt på kunst i hele landet, støttede projekter og kunstnerne bag.\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "newsletter-subscribe-popup-content" }, [
      _c("iframe", {
        attrs: {
          id: "newsletter-subscribe-popup-iframe",
          title: "Subscribe newsletter",
          src:
            "/typo3conf/ext/kunst_design/Resources/Public/newsletter/iframe.html?v=1"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "newsletter-subscribe-popup-footer" }, [
      _vm._v(
        "\n                Ønsker du information om puljer inden for de enkelte kunstområder?\n                "
      ),
      _c("u", [
        _c("a", { attrs: { href: "https://www.kunst.dk/abonner" } }, [
          _vm._v("Tilmeld dig her")
        ])
      ]),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "pt-3" }, [
        _vm._v(
          "\n                Ved tilmelding til Statens Kunstfonds nyhedsbreve, giver du samtidig samtykke til, at\n                Slots- og Kulturstyrelsen behandler oplysningerne i din henvendelse i henhold til\n                "
        ),
        _c("u", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.kunst.dk/kontakt/persondatapolitik",
                target: "_blank"
              }
            },
            [_vm._v("\n                    Persondataforordningen")]
          ),
          _vm._v(".\n                ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }